import React from "react";
import { useDashLayoutCtx } from "../DashLayoutCtxProvider";
import { Box, Grid2, Typography } from "@mui/material";
import TabHeading from "../../../common/tabs/TabHeading";
import TruckIcon from "@mui/icons-material/LocalShippingOutlined";

function SavedTruckList({ setRegNo, setInputField }) {
  const { setsplitView, savedTrucks } = useDashLayoutCtx();
  return (
    <>
      {savedTrucks?.length > 0 && (
        <Box
          sx={{
            width: "calc(100% - 80px)",
            margin: "20px 40px 0px 40px",
          }}
        >
          <TabHeading heading={"Saved • " + savedTrucks.length} />
          <Box
            sx={{
              overflowY: "auto",
              height: "200px",
            }}
          >
            {" "}
            <Grid2
              container
              spacing={2}
              sx={{
                mt: "20px",
              }}
            >
              {savedTrucks.map((item, index) => (
                <Grid2
                  key={index}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                  }}
                >
                  <Box
                    sx={{
                      background: "var(--saved-truck-bg)",
                      borderRadius: "4px",
                      display: "flex",
                      flexDirection: "row",
                      padding: "15px",
                      cursor: "pointer",

                      overflowX: "hidden",
                    }}
                    onClick={() => {
                      setsplitView(true);
                      setRegNo(item.rc_no);
                      setInputField(item.rc_no);
                    }}
                  >
                    <Typography
                      fontSize={"0.9rem"}
                      fontWeight={500}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <TruckIcon
                        sx={{
                          mr: "10px",
                          opacity: "0.25",
                        }}
                      />
                      {item.rc_no}
                    </Typography>
                  </Box>
                </Grid2>
              ))}
            </Grid2>
          </Box>
        </Box>
      )}
    </>
  );
}

export default SavedTruckList;
